import React, { Component } from "react";
import { TextField } from "reactackle";
import { isMobile } from "react-device-detect";

class TextInputField extends Component {
  render() {
    return (
      <div
        className="row"
        style={{
          marginLeft: "1px",
          marginRight: "1px",
          alignItems: "center",
          padding: "2px",
          border: "0px",
          borderBottom: "0px",
          borderBottomColor: "#cccccc",
          borderStyle: "solid",
          paddingBottom: isMobile ? "0px" : "2px"
        }}
      >
        <div
          className="col-sm-4 align-self-centerâ€"
          style={{
            margin: "0px",
            verticalAlign: "middle",
            height: "auto",
            padding: "0px"
          }}
        >
          <div
            style={{
              marginTop: isMobile ? "13px" : "0px",
              verticalAlign: "middle",
              lineHeight: isMobile ? "20px" : "37px",
              padding: "0px",
              color: isMobile ? "black" : "black",
              marginBottom: isMobile ? "-1px" : "0px"
            }}
          >
            {this.props.title}
          </div>
        </div>
        <div
          className="col-sm-8"
          style={{
            padding: "1px",
            textAlign: "right",
            border: "1px solid gainsboro",
            borderRadius: isMobile ? "5px" : "0px",
            backgroundColor: "white"
          }}
        >
          <TextField
            value={this.props.value}
            onChange={e => {
              this.props.stateChangeHandler(
                e.value,
                this.props.fieldName,
                true
              );
            }}
            {...this.props}
            fullWidth
          />
        </div>
      </div>
    );
  }
}

export default TextInputField;



// WEBPACK FOOTER //
// ./src/app/components/Screens/FieldsComponents/TextInputField/TextInputField.jsx